<template>
    <div v-loading="loading">
        <strong class="text-md">Your account API token is: </strong>
        <div class="input-group width-300">
            <input class="form-control text-md"
                   style="resize: none; background-color: #eff0f1;"
                   ref="api_token"
                   :type="companyTokenElementType"
                   :value="current_company.form_capture_token"
                   disabled
                   @click="copyApiToken">
            <span class="input-group-append">
                <button class="btn"
                        type="button"
                        @click="toggleCompanyTokenVisibility">
                    <i class="fa fa-eye-slash"></i>
                </button>
                <button class="btn greenish"
                        v-popover:api-popover
                        type="button"
                        @click="copyApiToken">
                    Copy
                </button>
            </span>
        </div>
        <div class="mt-2">
            <el-button @click="resetToken">
                Generate new token
            </el-button>
        </div>
    </div>
</template>

<script>
import {mapActions} from "vuex"
import {company_token_mixin, kyc_mixin} from '../../mixins'

export default {
    name: "company-form-token",

    computed: {
        companyTokenElementType() {
            return this.companyTokenVisibility ? 'text' : 'password'
        },
    },

    mixins: [
        kyc_mixin,
        company_token_mixin
    ],

    data() {
        return {
            loading: false
        }
    },

    methods: {
        ...mapActions('cache', ['setCurrentCompany']),

        copyApiToken() {
            navigator.clipboard.writeText(this.current_company.form_capture_token);
        },

        resetToken() {
            this.$confirm('Are you sure you want to reset your API token? WARNING: the current token will invalidated any application using it. ARE YOU SURE?', 'Form Capture Token Reset', {
                confirmButtonText: 'Yes',
                confirmButtonClass: 'bg-red border-danger',
                cancelButtonText: 'No',
                customClass: 'width-400 fixed form-capture-token-reset-pop-up',
                type: 'warning'
            }).then(() => {
                this.loading = true
                axios.post('/api/v1/company/form-token-reset')
                    .then(res => {
                        this.loading = false
                        this.$notify({
                            offset: 95,
                            title: 'Integrations',
                            message: res.data.message,
                            type: 'success'
                        })
                        // Update current company state
                        let company = this.current_company
                        company.form_capture_token = res.data.form_capture_token
                        this.setCurrentCompany(company)
                    })
                    .catch(err => {
                        this.loading = false
                        this.$root.handleErrors(err.response)
                    })
            })
        }
    }
}
</script>
